import PROXY_CONFIG from "../Config/ProxyConfig";
import api_call_v2 from "./API_CALL/api_call_v2";

async function getRPCQfromCoords({ lat, lng }) {
  let results = await api_call_v2(
    undefined,
    "post",
    "cartographie/rgc",
    {
      lat: lat ? lat : 0,
      lng: lng ? lng : 0,
    }
  )
  return results.data;
}

export default getRPCQfromCoords;
